export const isIOSSafariOrAndroidChrome = () => {
  if (isIOS() && navigator.userAgent.match(/safari/i)) {
    return true;
  }
  if (
    navigator.userAgent.match(/android/i) &&
    navigator.userAgent.match(/chrome|chromium|crios/i)
  ) {
    return true;
  }
  return false;
};

export const isMobileBrowser = () => {
  const toMatch = [/Android/i, /iPhone/i, /iPad/i, /iPod/i];

  return toMatch.some((toMatchItem) => {
    return (
      navigator.userAgent.match(toMatchItem) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  });
};

export const isIOS = () => {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
};

export const defaultUserMessage: string = "Okänt fel. Försök igen.";

export const errorCodeToUserMessage = (errorCode: string) => {
  switch (errorCode) {
    case "cancelled":
      return "Åtgärden avbruten. Försök igen.";
    case "alreadyInProgress":
      return "En identifiering eller underskrift för det här personnumret är redan påbörjad. Försök igen.";
    case "requestTimeout":
    case "maintenance":
    case "internalError":
      return "Internt tekniskt fel. Försök igen.";
    default:
      return defaultUserMessage;
  }
};

export const hintCodeToUserUserMessage = (hintCode: string) => {
  switch (hintCode) {
    case "userCancel":
      return "Åtgärden avbruten.";
    case "expiredTransaction":
      return "BankID-appen svarar inte. Kontrollera att den är startad och att du har internetanslutning. Om du inte har något giltigt BankID kan du hämta ett hos din bank. Försök sedan igen.";
    case "certificateErr":
      return "Det BankID du försöker använda är för gammalt eller spärrat. Använd ett annat BankID eller hämta ett nytt hos din internetbank.";
    case "startFailed":
      return "Misslyckades att läsa av QR koden. Starta BankID-appen och läs av QR koden. Kontrollera att BankID-appen är uppdaterad. Om du inte har BankID-appen måste du installera den och hämta ett BankID hos din internetbank. Installera appen från din appbutik eller https://install.bankid.com.";
    default:
      return defaultUserMessage;
  }
};
